import React from 'react';
import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import CancelIcon from '@material-ui/icons/Cancel';
import IconButton from '@material-ui/core/IconButton';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';

export const FileExtensionAlert = (props) => {

  const { open, handleExtensionAlertClose, file} = props;
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle }}} onClose={handleExtensionAlertClose} open={open}>
      <Box className={classes.root}>
        <IconButton onClick={handleExtensionAlertClose} className={classes.closeIco}>
            <CancelIcon />
        </IconButton>
        <Box className={classes.cardBody}>
          <Typography className={classes.statusTitle}>File Extension Alert</Typography>
        </Box>
        
        <Box className={classes.cardBodyContainer}>
          <Box className={classes.statusContainer}>
           <Box className={classes.cardContainer}>
             <Typography className={classes.paragraph}>The specified file "{file}" could not be uploaded.</Typography> 
             <Typography className={classes.paragraph}>Files with allowed extensions: .jpeg, .jpg, .png and .pdf.</Typography> 
            </Box> 
          </Box>
        </Box>

        <Box className={classes.cardFooter}>
          <Button
            variant='contained'
            color='primary'
            className={classes.btn}
            onClick={handleExtensionAlertClose}
            >Got it</Button>
        </Box>
      </Box> 
    </Dialog>
  )
}
